module.exports = __webpack_public_path__ + "media/big_news.c156d72a70f0cfc7743963029d31e606.svg";